// i18n area 'storage' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.fr-FR.meta.json.
import type { enUS } from './storage'

export const frFR: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Créer un storage',
      path: 'Chemin',
      pathHint: 'Chemin absolu sous une root autorisée (default /var/lib/tvirt/pools/)',
      shared: 'Storage partagé',
      sharedChip: 'partagé',
      sharedVerifiedChip: 'partagé · vérifié',
      sharedVerifiedTooltip: 'Partage vérifié : les sondes croisées confirment que chaque membre voit les données écrites par les autres.',
      sharedDisputedChip: 'partagé · NON vérifié',
      sharedDisputedTooltip: 'Partage NON vérifié',
      sharedDisputedPair: '{observer} ne voit pas les données écrites par {writer}',
      sharedHint: 'Share réseau montée localement au même path sur chaque membre — le prérequis de la live migration (déclaratif).',
      sharedDanger: "DANGER — TVirt CROIT ce flag : en l'allumant, chaque membre suppose voir LES MÊMES bytes à ce path. Sur un dossier qui n'est PAS une share réellement partagée (NFS/CIFS/filesystem de cluster) le résultat est corruption et perte de données à la première migration ou au premier redémarrage HA sur un autre nœud. Allumez-le seulement si le path est une share montée à l'identique sur chaque nœud.",
      type: 'Type',
      capacity: 'Capacité',
      provisioned: 'Allouée',
      provisionedOvercommit: "Engagement potentiel au-delà de la capacité : les volumes thin peuvent grandir jusqu'à {n} GiB.",
      phase: { ready: 'Prêt', degraded: 'Dégradé', error: 'Erreur' },
      tabConfig: 'Configuration',
      tabCapacity: 'Capacité et état',
      cardIdentity: 'Identité',
      cardPlacement: 'Emplacement',
      cardConnection: 'Connexion',
      usedReal: 'Occupation réelle',
      capacityUnknown: "Le nœud n'a pas encore rapporté la capacité de ce pool — ici on n'invente pas de chiffres",
      overcommitHint: "Engagement au-delà de la capacité : légitime sur les pools thin, gardez un œil sur l'occupation réelle",
      supportedContent: 'Contenus supportés',
      content: {
        disks: 'Disques',
        catalogFiles: 'Fichiers de catalogue',
        backups: 'Backups',
        appVolumes: 'Volumes App'
      },
      defaultDiskFormat: 'Format de disque par défaut',
      reserveGiB: 'Espace libre réservé (GiB)',
      available: 'Disponible',
      diskCount: 'Disques',
      filesystem: 'Filesystem',
      observedAt: 'Observé le',
      lostAtRow: 'Déclaré perdu le',
      sharedProbeRow: 'Vérification du partage',
      sharedProbeNodes: 'Nœuds sondés',
      reachableFrom: 'Joignabilité déclarée',
      reachableFromHint: "Les nœuds depuis lesquels ce storage doit être joignable. Une VM avec des disques, des ISO ou des métadonnées ici ne démarre ni ne migre sur un nœud hors de cette liste. Tous les membres sont présélectionnés : restreignez comme vous voulez. Un nœud qui rejoint le cluster plus tard reste en dehors jusqu'à ce que vous l'ajoutiez ici.",
      reachableFromNone: 'non déclarée',
      reachableFromTags: 'Accessibilité par tag',
      reachableFromTagsHint: 'Sélecteur tag=valeur (entrées séparées par des virgules, en AND) : chaque membre portant ces tags est déclaré accessible — dynamiquement : taguer un nœud le fait entrer.',
      reachableFromTagsInvalid: 'Format invalide — utilisez tag=valeur, séparés par des virgules',
      reachableResolved: 'Nœuds résolus : {nodes}',
      reachableDeclaredNotSeen: 'déclaré mais non vu par la sonde de partage sur : {nodes}',
      reachableSeenNotDeclared: 'vu mais non déclaré (hors périmètre) sur : {nodes}',
      cephCluster: 'Cluster Ceph géré',
      appGuardTitle: 'Storage utilisé par les Apps',
      appEphemeralGuard: "ce storage est le pool éphémère de cluster des Apps — changez-le d'abord depuis la page Apps, puis supprimez-le.",
      appInUseGuard: "des roots/volumes d'app vivent ici : {apps} — déplacez-les ou supprimez-les d'abord.",
      releaseRequiredTitle: "Supprimer '{name}' et libérer ses images ?",
      releaseRequiredBatchTitle: 'Supprimer les storages sélectionnés et libérer leurs images ?',
      releaseRequiredBody: "Libérer les images ne supprime AUCUN octet : le désenregistrement laisse le namespace sur le disque, les images cessent simplement d'être matérialisées et chaque référence des scopes survit comme claim — réenregistrez le pool et elles sont réadoptées.",
      releaseConfirm: 'Supprimer et libérer les images'
    },
    lost: {
      chip: 'Perdu',
      action: 'Déclarer perdu',
      confirmTitle: 'Déclarer le storage perdu',
      confirmBody: "Attestation de l'opérateur à son propre risque déclaré : chaque task en file ou en cours sur ce storage ou ses objets ÉCHOUERA, les suppressions deviennent purement au registre (aucun travail sur le filesystem) et le nouveau travail physique est refusé. Les bytes ne sont jamais touchés — si le volume revient à la vie, enregistrez-le à nouveau et lancez un scan pour tout ré-adopter.",
      confirmSubmit: 'Déclarer perdu',
      error: "L'attestation a été refusée"
    },
    findings: {
      action: 'Objets trouvés',
      title: 'Objets trouvés',
      empty: 'Aucun objet trouvé dans le namespace du storage',
      loadError: 'Impossible de charger les objets trouvés',
      actionError: 'La décision a été refusée',
      colKind: 'Type',
      colObject: 'Objet',
      colConflict: 'Conflit',
      namespaceNotice:
        "Ce répertoire avait déjà été initialisé par un autre stockage : le sceau d'identité a été réécrit avec celui de ce stockage. Le contenu n'a PAS été touché — examinez les objets trouvés ci-dessous, importez ceux dont vous avez besoin, puis ignorez cet avis.",
      kind: {
        disk: 'Disque',
        catalogFile: 'Fichier de catalogue',
        vmMetadata: 'Metadata VM',
        namespace: 'Namespace',
        foreign: 'Étranger',
        volumeGroup: 'Groupe de volumes'
      },
      vgAdopt: {
        action: 'Adopter le groupe de volumes',
        title: 'Adopter le groupe de volumes',
        intro:
          'Ce périphérique porte déjà un groupe de volumes avec un nom de TVirt, mais son sceau ne nomme aucun storage enregistré ici. Ce peut être ce qu\'un storage précédent de CE cluster a laissé sur la LUN, ou ce qu\'UN AUTRE cluster TVirt a laissé sur une LUN qui a changé de mains : d\'ici les deux cas sont identiques, et c\'est pourquoi personne ne décide à votre place.',
        irreversible: 'Regardez le périphérique, le sceau et le nom avant de continuer : l\'adoption est irréversible.',
        device: 'Périphérique',
        seal: 'Sceau',
        sealNone: 'aucun (pas d\'étiquette tvirt.storageId)',
        renameTo: 'Il sera renommé en',
        renameNone: 'Aucun renommage : le nom est déjà celui que ce storage dérive',
        volumesNote:
          'Les volumes contenus ne sont PAS adoptés par ce geste : le prochain scan les propose un par un, comme des objets trouvés ordinaires.'
      },
      conflictChip: 'ID déjà existant',
      dismissedChip: 'Ignoré',
      adopt: 'Adopter',
      adoptFileTitle: 'Importer dans un catalogue',
      adoptFileHint: "Les fichiers n'existent qu'à l'intérieur des catalogues : choisissez le catalogue de destination pour le fichier trouvé.",
      purge: 'Supprimer du disque',
      dismiss: 'Ignorer',
      purgeConfirmTitle: 'Supprimer du disque',
      purgeConfirmBody: "Les bytes trouvés de {id} seront retirés du storage. L'opération n'est pas réversible.",
      taskStarted: 'Démarré — se poursuit comme task en background',
      scan: 'Scanner le storage',
      scanStarted: 'Scan démarré…',
      scanDone: 'Scan terminé — les objets trouvés sont à jour'
    },
    reinit: {
      action: "Réessayer l'initialisation"
    },
    wizard: {
      addButton: 'Ajouter',
      title: 'Ajouter un storage',
      back: 'Retour',
      continue: 'Continuer',
      selectHint: "Sélectionnez un protocole pour voir comment TVirt l'utilise.",
      roadmap: 'Roadmap',
      server: 'Serveur',
      export: 'Chemin exporté',
      share: 'Share',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      passwordHint: 'Écriture seule : utilisé pour le mount, jamais plus affiché.',
      credential: 'Identifiants',
      credentialManual: 'Saisir manuellement',
      credentialHint: "Une entrée du keystore de type nom d'utilisateur et mot de passe — l'alternative à les taper ici.",
      credentialEmpty: "Aucun identifiant de type nom d'utilisateur et mot de passe dans le keystore — créez-le dans Système → Identifiants, ou tapez le compte ci-dessous.",
      options: 'Options de mount',
      optionsHint: 'Séparées par des virgules, passées à mount -o telles quelles.',
      portal: 'Portal',
      portalHint: 'host[:port] — le port par défaut est 3260.',
      target: 'Target IQN',
      targetHint: 'Le nom du target iSCSI, commence par iqn.',
      lun: 'LUN',
      wholeLunRow: 'Sur les disques : ce stockage ne nomme que la cible',
      wholeLunHint: 'Ce stockage ne nomme que la cible : ses LUN deviennent des disques une à une (Créer un disque → adopter une LUN entière), rien n\'est écrit sur la cible.',
      lunHint: 'Numéro de la LUN sur le target — 0 dans le doute.',
      chapCredential: 'Identifiants (CHAP)',
      chapCredentialHint: 'Une entrée du keystore de type CHAP (iSCSI) utilisée pour le login — le secret ne voyage jamais avec le storage.',
      chapNone: 'Aucune authentification',
      chapEmpty: 'Aucun identifiant de type CHAP (iSCSI) dans le keystore — créez-le dans Système → Identifiants. Sans cela, le login reste non authentifié.',
      address: 'Adresse',
      addressHint: 'Host ou IP du target NVMe/TCP (traddr).',
      port: 'Port',
      portHint: 'Port TCP du target — 4420 si laissé vide.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Le NQN du subsystem sur le target, commence par nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID dans le subsystem — 1 dans le doute.',
      dhchapCredential: 'Identifiants (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Une entrée du keystore de type DH-HMAC-CHAP (NVMe) utilisée à la connexion — le secret ne voyage jamais avec le storage.',
      dhchapNone: 'Aucune authentification',
      dhchapEmpty: 'Aucun identifiant de type DH-HMAC-CHAP (NVMe) dans le keystore — créez-le dans Système → Identifiants. Sans cela, la connexion reste non authentifiée.',
      monitors: 'Monitors',
      monitorsHint: 'Endpoints des monitors Ceph, host[:port], séparés par des virgules ou des retours à la ligne — port par défaut 6789.',
      pool: 'Pool',
      poolHint: 'Le pool RBD à consommer — une image RBD par disque.',
      fs: 'Filesystem',
      fsHint: 'Le nom du filesystem CephFS (mds_namespace au mount).',
      fsPath: 'Path dans le filesystem',
      fsPathHint: 'Path absolu dans le filesystem que le storage monte — / dans le doute.',
      cephxCredential: 'Identifiants (cephx)',
      cephxCredentialHint: 'Une entrée du keystore de type cephx : username = nom de client (client.…), secret = la clé base64. Obligatoire.',
      cephxNone: 'Aucun identifiant cephx dans le keystore — créez-en un (type : cephx) dans Système → Identifiants, ou laissez un cluster Ceph géré le frapper via "Proposer comme storage".',
      sharedByNature: 'Les storages réseau sont partagés par nature : chaque membre les monte au même chemin géré par TVirt.',
      error: 'Le storage a été refusé',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Autre',
        legacy: 'Legacy'
      },
      legacyHint: 'Supportés à part entière — simplement, nous ne les choisirions pas pour une nouvelle installation.',
      proto: {
        dir: {
          name: 'Dossier local',
          desc: "Une directory du nœud : simple et rapide. Elle est LOCALE à un nœud, à moins que le path ne soit une share réellement partagée — la marquer partagée quand elle ne l'est pas coûte des données.",
          usage: 'TVirt y conserve des disques de VM, des images ISO/disque et des templates.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Un export NFS monté par le cluster — partagé par nature.',
          usage: 'Héberge des disques de VM, des images ISO/disque et des templates.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Une share Windows/Samba montée par le cluster — partagée par nature.',
          usage: 'Héberge des disques de VM, des images ISO/disque et des templates.'
        },
        sftp: {
          name: 'SFTP',
          desc: "Un filesystem distant via SSH — sans besoin d'export NAS.",
          usage: 'Sur la roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Des LUN bloc via IP avec du LVM partagé par-dessus.',
          usage: "Disques seulement — un volume thin par disque ; n'héberge ni images ISO ni templates."
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Des block devices distribués sur un cluster Ceph.',
          usage: "Disques seulement — une image RBD par disque, ouverte nativement par QEMU ; n'héberge pas d'images ISO."
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Le filesystem distribué de Ceph, monté par le kernel sur le cluster — shared by nature.',
          usage: 'Héberge des disques VM, des images ISO/disque et des templates — la famille dir sur un filesystem Ceph (identifiant cephx obligatoire).'
        },
        fc: { name: 'SCSI/FC', desc: 'Des LUN SCSI sur fabric FibreChannel — le SAN FC classique.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Le même SCSI sur FibreChannel, avec les frames FC encapsulées dans Ethernet.' },
        'iscsi-lun': {
          name: 'iSCSI (LUN entières)',
          desc: 'La cible iSCSI comme porteur de LUN entières : chaque disque EST une LUN, passée brute à l\'invité — pas de LVM entre les deux.',
          usage: 'Disques seulement — une LUN entière par disque, adoptée telle quelle ; la maison SAN des disques en écriture partagée.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (namespaces entiers)',
          desc: 'Le sous-système NVMe comme porteur de namespaces entiers : chaque disque EST un namespace, passé brut à l\'invité.',
          usage: 'Disques seulement — un namespace entier par disque, adopté tel quel ; écriture partagée oui, persistent reservations SCSI non.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'NVMe distant — aucun SCSI sur le chemin — sur du TCP simple, avec du LVM partagé par-dessus.',
          usage: "Disques seulement — un volume thin par disque ; n'héberge ni images ISO ni templates."
        },
        nvmefc: { name: 'NVMe/FC', desc: 'NVMe distant sur fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe sur le fabric FibreChannel que FCoE transporte dans Ethernet — les layers FCoE et NVMe/FC empilés.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: "iSCSI avec le chemin de données déplacé sur RDMA — n'importe quel fabric (InfiniBand, iWARP, RoCE). Dépassé par NVMe/RDMA, encore présent dans les arrays et dans ESXi." },
        srp: { name: 'SCSI/RDMA (SRP)', desc: "SCSI natif sur RDMA, l'ère pré-iSER : InfiniBand (avec le discovery de fabric) et RoCE — survit dans les storages HPC datés." },
        nvmerdma: { name: 'NVMe/RDMA', desc: "NVMe distant sur n'importe quel fabric RDMA — InfiniBand, iWARP, RoCE v1 et v2 : une seule configuration, c'est le nœud qui dit lequel il a." },
        s3: { name: 'S3', desc: 'Object storage compatible S3 — images et backups.' }
      }
    },
    catalogs: {
      title: 'Catalogues',
      createTitle: 'Créer un catalogue',
      editTitle: 'Modifier le catalogue',
      docTitle: 'Catalogue',
      notFound: "Ce catalogue n'existe pas (plus ?)",
      scopeHint: 'Quiconque lit ce scope voit (et peut utiliser) chaque fichier du catalogue',
      files: 'Fichiers',
      noFiles: 'Aucun fichier',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },
      systemChip: 'système',
      systemTooltip: 'Catalogue système : il héberge les objets intégrés de la plateforme et ne peut pas être modifié'
    },
    catalogFiles: {
      catalog: 'Catalogue',
      kindLabel: 'Type',
      physicalSize: 'Taille physique',
      virtualSize: 'Taille virtuelle',
      importTemplateAction: 'Importer comme VM Template',
      importTemplateLegacy: 'Aucun format déclaré — utilisable comme seed pour disques, non importable',
      importTemplateTitle: 'Importer comme VM Template',
      importTemplateSubmit: 'Importer',
      importTemplateError: "L'import a échoué",
      importTemplateHint: "Le package .tvtpl devient un VM Template : le hardware congelé du manifest plus un disque par entry de l'archive, chacun vérifié contre son checksum. Les NIC et les supports CD/DVD ne font pas partie d'une archive — ajoutez-les après l'import.",
      importTemplateQcow2Hint: "Un qcow2 nu devient un template à UN disque avec le hardware par défaut déclaré : profil linux, UEFI, 2 vCPU, 2048 MiB, boot depuis son unique disque. Ajustez au deploy.",
      importTemplateName: 'Nom du template',
      importTemplateNameHint: 'Vide = {name} (-import-<n> si pris)',
      importTemplateStorage: 'Storage pour les disques',
      importTemplateMetadataStorage: 'Storage des métadonnées',
      importTemplateMetadataHint: "Un storage bloc n'héberge pas les métadonnées VM (firmware, varstore) — choisissez-en un dir/nfs/cifs.",
      importTemplateStarted: 'Import démarré — le template apparaît dans le tab Templates à la fin de la task.',
      kind: {
        iso: 'Image ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Template VM',
        'oci-image': 'Image OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Images ISO',
        'ct-rootfs': 'Templates CT',
        'vm-template': 'Templates VM',
        'oci-image': 'Images OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Ajouter une image ISO',
        'ct-rootfs': 'Enregistrer un template CT',
        'vm-template': 'Ajouter un template VM',
        'oci-image': 'Ajouter une image OCI',
        'firmware-ovmf': 'Ajouter un firmware OVMF'
      },
      formatHint: "Dérivé de l'extension du fichier choisi — corrigez-le s'il a mal deviné",
      tarballHint: 'Un tarball rootfs au format LXC standard (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, ou un simple .tar)',
      ociArchiveHint: 'Un tarball docker-archive / oci-archive (.tar ou .tar.gz), par exemple issu de docker save',
      uploadResumeHint: "Upload interrompu — le fichier est en attente d'upload : soumettez à nouveau avec le même fichier pour reprendre",
      moveTitle: 'Déplacer le fichier',
      moveHint: 'Deux dimensions indépendantes : le Catalogue déplace le lien (même id, aucun byte ne bouge, le scope devient celui du catalogue de destination) ; le Storage déplace les données — chaque copie liée le suit, refusé tant que le fichier est en usage. Choisis ensemble : d\'abord le catalogue, puis le storage.',
      moveCatalog: 'Catalogue de destination',
      moveCatalogHint: 'Seul le lien change de maison : une VM qui monte le fichier doit pouvoir voir le catalogue de destination',
      keepCurrent: 'Ne pas changer',
      rehomed: 'Lien déplacé dans le catalogue choisi',
      copyAction: 'Copier dans un catalogue…',
      copyTitle: 'Copier dans un catalogue',
      copyLinkHint: "La copie est un nouveau lien vers les mêmes données — rien n'est dupliqué sur le storage.",
      copyCatalog: 'Catalogue de destination',
      copyCatalogHint: 'La copie est la façon dont un fichier voyage entre catalogues',
      sameCatalog: 'Le même que la source',
      sharedObjectHint: 'Les données de ce fichier sont partagées par {count} copies liées',
      deleteLastLink: 'Ceci est le DERNIER lien vers ce contenu : les données seront supprimées du storage elles aussi.',
      deleteLinkOnly: 'Seul ce lien sera retiré — les données restent, toujours accessibles via les autres copies liées ({count}).',
      noCatalog: "Il n'y a aucun catalogue — créez-en un",
      inlineCatalogName: 'Nom du catalogue',
      embeddedChip: 'intégré',
      embeddedStorage: 'Intégré à la plateforme',
      embeddedNoMove: 'Fichier intégré de la plateforme : il ne vit sur aucun storage — clonez-le plutôt',
      embeddedCopyHint: 'Le clone matérialise les bytes intégrés sur un vrai storage : choisissez le storage et le catalogue de destination — la copie est un fichier ordinaire',
      sourceEmbedded: 'Intégré à la plateforme',
      nodesRow: 'Présence par nœud',
      nodesSummary: '{present} nœuds sur {total} le possèdent',
      nodePresent: 'présent',
      nodeMissing: 'absent',
      nodeUnknown: 'pas encore signalé',
      nodesHint: 'L\'asset vit sur le disque de chaque nœud (paquet trantor-tvirt-assets) : un nœud qui ne l\'a pas ne peut ni définir une VM avec ce firmware ni servir les Guest Tools. Des versions différentes entre les nœuds sont normales pendant une mise à jour progressive.',
      downloadAction: 'Télécharger',
      downloadNotReady: "Le contenu n'est pas encore prêt — le download exige un fichier ready",
      downloadDenied: "Votre rôle n'inclut pas catalog.download — télécharger les bytes est un droit séparé de l'usage du fichier",
      objectRow: 'Objet storage',
      objectLinksRow: 'Copies liées',
      declaredChecksum: 'SHA-256 déclaré',
      usedByRow: 'Utilisé par',
      usedByVms: 'VM',
      usedByDisks: 'Disques',
      transferRow: 'Transfert',
      storageLockHint: "Ne change que via l'action Déplacer"
    },
    objects: {
      action: 'Explorer les contenus',
      title: 'Contenus du storage',
      hint: 'Recensement en lecture seule de ce qui vit sur ce storage — chaque objet se gère depuis sa section.',
      empty: 'Aucun objet enregistré sur ce storage',
      loadError: 'Impossible de charger les contenus',
      colDetail: 'Détail',
      manage: 'Gérer dans sa section',
      kind: {
        disk: 'Disque',
        catalogFile: 'Fichier de catalogue',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadata VM',
        appRoot: 'Root App',
        appVolume: 'Volume App'
      }
    },
    inventory: {
      tabCatalogs: 'Catalogues',
      storage: 'Storage',
      sizeGib: 'Taille (GiB)',
      format: 'Format',
      size: 'Taille',
      sourceType: 'Source',
      sourceFile: 'Envoi de fichier',
      sourceUrl: 'Download depuis URL',
      file: 'Fichier',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Obligatoire : le download est vérifié contre ce SHA-256',
      verifyChecksum: 'Vérifier le checksum',
      checksumOffHint: 'Le download sera accepté sans vérification — le SHA-256 calculé est tout de même enregistré',
      uploading: 'Envoi en cours…',
      move: {
        action: 'Déplacer',
        diskTitle: 'Déplacer le disque',
        target: 'Storage de destination',
        diskHint: "Le disque conserve son identité : les bytes voyagent vers le storage choisi. Une VM qui l'utilise doit être éteinte ; avec des snapshots présents, un côté iSCSI refuse le déplacement.",
        noTargets: 'Aucun storage de destination compatible',
        submit: 'Déplacer',
        error: 'Le déplacement a été refusé'
      },
      clone: {
        action: 'Cloner',
        title: 'Cloner le disque',
        name: 'Nom de la copie',
        storage: 'Storage de destination',
        sameStorage: 'Le même que la source',
        linked: 'Linked clone',
        linkedHint: 'Overlay qcow2 instantané enchaîné au disque source (sources qcow2 seulement). Le default est une copie complète.',
        linkedCrossHint: 'Un linked clone reste sur le storage de la source : choisissez "Le même que la source" pour l\'activer.',
        submit: 'Cloner',
        error: 'Le clonage a été refusé'
      },
      copy: {
        action: 'Copier',
        name: 'Nom de la copie',
        storage: 'Storage de destination',
        sameStorage: 'Le même que la source',
        submit: 'Copier',
        error: 'La copie a été refusée'
      },
      taskStarted: 'Démarré — se poursuit comme task en background',
      cephObjects: "Aller aux détails de l'objet sur Ceph",
      phase: {
        ready: 'Prête',
        creating: 'En création',
        'awaiting-upload': "En attente d'upload",
        downloading: 'En download',
        verifying: 'En vérification',
        deleting: 'En suppression',
        error: 'Erreur',
        'in-use': 'En usage'
      }
    }
  }
}
